import api_url from "./api_url";

export const fetchEventNewsSpeech = async () => {
    try {
        const response = await fetch(`${api_url}/api/events_news`);
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: "Failed to fetch posts" };
    }
};

export const publishEventNewsSpeech = async (id) => {
    try {
        const response = await fetch(`${api_url}/api/events_news/${id}/publish`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: "Failed to publish post" };
    }
};